import { Article, Heading, P } from '@slal/ui/typography';
import { StyledHelpPhoneNumber, StyledOpeningHours, StyledPhoneNumber } from './styles';
import { Card } from '~/components';
import { PhoneIcon } from '@slal/ui/icons';

export const ApplicationHelp = () => (
    <Card>
        <Article aria-labelledby="application--help">
            <Heading id="application--help" level={3}>
                Need some help?
            </Heading>
            <StyledHelpPhoneNumber>
                <PhoneIcon /> <StyledPhoneNumber>0345 266 8013</StyledPhoneNumber>
            </StyledHelpPhoneNumber>
            <StyledOpeningHours aria-labelledby="application--opening-hours">
                <Heading id="application--opening-hours" level={5}>
                    Opening hours
                </Heading>
                <P>
                    Monday to Tuesday 09:00 - 17:00
                    <br />
                    Wednesday 10:00 - 17:00
                    <br />
                    Thursday to Friday 09:00 - 17:00
                    <br />
                    Call charges will vary
                </P>
            </StyledOpeningHours>
        </Article>
    </Card>
);
